import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { TranslocoModule } from '@jsverse/transloco';
import { AuthService } from '../../core/auth/auth.service';

@Component({
  selector: 'app-forgot-password',
  standalone: true,
  imports: [CommonModule, TranslocoModule, ReactiveFormsModule],
  templateUrl: './forgot-password.component.html',
  styleUrl: './forgot-password.component.scss',
})
export class ForgotPasswordComponent {
  public forgotPasswordGroup: FormGroup = new FormGroup({
    email: new FormControl('', [Validators.required, Validators.email]),
  });

  constructor(private fb: FormBuilder, private authService: AuthService, private router: Router) {}

  public onClickSubmit(): void {
    // this.authService.passwordResetSendMail(this.forgotPasswordGroup.value.email).then(() => {
    //   this.router.navigate(['/forgot-password-success'], { queryParams: { redirectUrl: this.authService.redirectUrl } });
    // });
  }

  public onClickCancel(): void {
    this.router.navigate(['/sign-in'], { queryParams: { redirectUrl: this.authService.redirectUrl } });
  }
}
